import {ClientContextId} from "common/types/client_context";

export interface DocumentContextValues {
  clientContext: string;
  clientContextId: ClientContextId | null;
}

export const EMPTY_DOCUMENT_CONTEXT: DocumentContextValues = {
  clientContext: "",
  clientContextId: null,
};

export function hasDocumentContext(values: DocumentContextValues): boolean {
  return values.clientContext.trim() !== "" || Boolean(values.clientContextId);
}
